import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getOperationsAxios,
  getStepsAxios,
  getActivitiesAxios,
  getCommentsAxios,
  getFilesAxios,
  getOperationUpdateAxios,
  getCompaniesAxios,
  getBusinessLineAxios,
  postChangeStatusAxios,
  postCreateOperationAxios,
  postUpdateOperationAxios,
  downloadFileAxios,
  postCreateCommentAxios,
  sendMailAxios,
  getContainersAxios,
  getStepAxios,
  saveOperationDraftAxios,
  getUsersAxios,
  getExternalUsersAxios,
  getBusinesslinesAxios,
  getRolesAxios,
  changeRoleAxios,
  createBusinessLineAxios,
  removeBusinessLineAxios,
  getAnalystsAxios,
  getAllCompaniesAxios,
  getOperationsdraftAxios,
  getOperationdraftbyidAxios,
  removeCompanyToUserAxios,
  deleteOperationDraftAxios,
  postUpdateActivityAxios,
  addCompanyToUserAxios,
  inactiveUserAxios,
  postCreateContaienrCommentAxios,
  getCommentContainersAxios,
  postSetEndDateActivityAxios,
  resendMailAxios,
  resendMailContainerAxios,
  sendMailContainerAxios,
  getFilesContainerAxios,
  downloadFileContainerAxios,
  getUrlQuickSightAxios,
  getEmailsAxios,
  getUsersResponsityAxios,
  postChangeResponsableOperationAxios,
  presignedRes,
} from '../../services/general';
import { showAlertSuccErr } from '../../utils/alert';

export const getOperations = createAsyncThunk('general/getOperations', async () => {
  try {
    const results = await Promise.allSettled([getOperationsAxios(), getOperationsdraftAxios()]);
    const operations = results[0].status === 'fulfilled' ? results[0]?.value?.data?.operations : [];
    const operations_draft =
      results[1].status === 'fulfilled' ? results[1]?.value?.data?.operations : [];
    const company = await getCompaniesAxios();
    const data = {
      ...company.data,
      operations,
      operations_draft,
    };
    return data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener las operaciones',
      icon: 'error',
    });
    throw error;
  }
});

export const getOperationUpdate = createAsyncThunk('general/getOperationUpdate', async (id) => {
  try {
    const response = await getOperationUpdateAxios(id);
    return response?.data?.operation;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getCompanies = createAsyncThunk('general/getCompanies', async () => {
  try {
    const response = await getCompaniesAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getSteps = createAsyncThunk('general/getSteps', async (id) => {
  try {
    const steps = await getStepsAxios(id);
    return steps?.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los steps',
      icon: 'error',
    });
    throw error;
  }
});

export const getStep = createAsyncThunk('general/getStep', async (id) => {
  try {
    const step = await getStepAxios(id);
    return step?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getActivities = createAsyncThunk('general/getActivities', async (id) => {
  try {
    const response = await getActivitiesAxios(id);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener las actividades',
      icon: 'error',
    });
    throw error;
  }
});

export const postUpdateActivity = createAsyncThunk('general/postUpdateActivity', async (data) => {
  try {
    if (data.operation_finished) {
      const st = {
        state: data.state,
      };
      const estado = postChangeStatusAxios(st, data.operation_id);
    }
    const actividad = await postUpdateActivityAxios(data);
    return actividad.data;
  } catch (error) {
    console.error('Error al actualizar la actividad', error);
    showAlertSuccErr({
      title: 'Error al actualizar la actividad',
      icon: 'error',
    });
    throw error;
  }
});

export const postSetEndDateActivity = createAsyncThunk(
  'general/postSetEndDateActivity',
  async (data) => {
    try {
      const actividad = await postSetEndDateActivityAxios(data);

      return actividad.data;
    } catch (error) {
      console.error('Error al actualizar la actividad', error);
      showAlertSuccErr({
        title: 'Error al actualizar la actividad',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const getComments = createAsyncThunk('general/getComments', async (id) => {
  try {
    const response = await getCommentsAxios(id);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los comentarios',
      icon: 'error',
    });
    throw error;
  }
});

export const getContainerComments = createAsyncThunk('general/getContainerComments', async (id) => {
  try {
    const response = await getCommentContainersAxios(id);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los comentarios',
      icon: 'error',
    });
    throw error;
  }
});

export const getFiles = createAsyncThunk('general/getFiles', async (id) => {
  try {
    const response = await getFilesAxios(id);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los archivos',
      icon: 'error',
    });
    throw error;
  }
});

export const getFilesContainer = createAsyncThunk('general/getFilesContainer', async (id) => {
  try {
    const response = await getFilesContainerAxios(id);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los archivos',
      icon: 'error',
    });
    throw error;
  }
});

export const getBusinessline = createAsyncThunk('general/getBusinessline', async () => {
  try {
    const response = await getBusinessLineAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getContainersOperation = createAsyncThunk(
  'general/getContainersOperation',
  async (id) => {
    try {
      const response = await getContainersAxios(id);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createComment = createAsyncThunk('general/createComment', async (data) => {

  try {
    let filesMeta = [];
    
   // 1. Por cada archivo, solicita URL prefirmada y sube a S3
      if (data.file && data.file.length > 0) {
        for (const file of data.file) {
          // Solicita la URL prefirmada
          const dataFile = { name: file.name, type: file.type };
          const presignedResponse = await presignedRes(dataFile);
          const { url, key } = presignedResponse.data;

          // Sube el archivo a S3
          await fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': file.type },
            body: file,
          });

          filesMeta.push({
            name: file.name,
            location: key,
            type: file.type,
          });
        }
      }

      console.log('files',filesMeta);

    // 2. Envía solo los metadatos al backend
      const body = {
        comment: data.comment,
        activity_id: data.activity_id,
        internal_comment: data.internal_comment || '',
        files: filesMeta,
      };


    const response = await postCreateCommentAxios(body);
    const st = {
      state: data.state,
    };
    const estado = postChangeStatusAxios(st, data.idOperation);
    showAlertSuccErr({
      title: 'Comentario creado exitosamente',
      icon: 'success',
    });
    return { ...response.data, files: filesMeta };
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al crear el comentario',
      icon: 'error',
    });
    throw error;
  }
});

// export const createContainerComment = createAsyncThunk(
//   'general/createContainerComment',
//   async (data) => {
//     try {

//       let filesMeta = [];
//       const formData = new FormData();

//       console.log('data', data);
//       formData.append('comment', data.comment);
//       formData.append('container_id', data.container_id);
//       formData.append('volume', data.volume);
//       formData.append('activity_id', data.activity_id);
//       formData.append('internal_comment', data.internal_comment);

//       if (data.file) {
//         formData.append('file', data.file);
//       }

//       for (let [key, value] of formData.entries()) {
//         console.log(`${key}: ${value}`);
//       }

//       const response = await postCreateContaienrCommentAxios(formData);
//       showAlertSuccErr({
//         title: 'Comentario creado exitosamente',
//         icon: 'success',
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//       showAlertSuccErr({
//         title: 'Error al crear el comentario',
//         icon: 'error',
//       });
//       throw error;
//     }
//   },
// );

export const createContainerComment = createAsyncThunk(
  'general/createContainerComment',
  async (data) => {
    console.log('requestdata', data)
    try {
      let filesMeta = [];

      // 1. Por cada archivo, solicita URL prefirmada y sube a S3
      if (data.file && data.file.length > 0) {
        for (const file of data.file) {
          // Solicita la URL prefirmada
          const dataFile = { name: file.name, type: file.type };
          console.log('dataFile',dataFile)
          const presignedResponse = await presignedRes(dataFile);
          const { url, key } = presignedResponse.data;

          // Sube el archivo a S3
          await fetch(url, {
            method: 'PUT',
            headers: { 'Content-Type': file.type },
            body: file,
          });

          filesMeta.push({
            name: file.name,
            location: key,
            type: file.type,
          });
        }
      }

      console.log('files',filesMeta);

      // 2. Envía solo los metadatos al backend
      const body = {
        comment: data.comment,
        container_id: data.container_id,
        volume: data.volume,
        activity_id: data.activity_id,
        internal_comment: data.internal_comment || '',
        files: filesMeta,
      };

      const response = await postCreateContaienrCommentAxios(body);

      showAlertSuccErr({
        title: 'Comentario creado exitosamente',
        icon: 'success',
      });
      return  { ...response.data, files: filesMeta };
    } catch (error) {
      console.error(error);
      showAlertSuccErr({
        title: 'Error al crear el comentario',
        icon: 'error',
      });
      throw error;
    }
  }
);

export const createOperation = createAsyncThunk('general/createOperation', async (data) => {
  try {
    const operation = await postCreateOperationAxios(data);
    showAlertSuccErr({
      title: 'Operacion creada exitosamente',
      icon: 'success',
    });
    return operation.data;
  } catch (error) {
    console.error('Error al crear la operacion', error);
    showAlertSuccErr({
      title: error.response.data.message ? error.response.data.message : error.response.data,
      icon: 'error',
    });
    throw error;
  }
});

export const fetchUpdateOperation = createAsyncThunk(
  'general/fetchUpdateOperation',
  async (data) => {
    try {
      const operation = await postUpdateOperationAxios(data, data?.operationid);
      showAlertSuccErr({
        title: 'Operacion actualizada exitosamente',
        icon: 'success',
      });
      return operation.data;
    } catch (error) {
      console.log(error);
      console.error('Error al crear la operacion', error);
      showAlertSuccErr({
        title: error.response.data.message ? error.response.data.message : error.response.data,
        icon: 'error',
      });
      throw error;
    }
  },
);

export const downloadFile = createAsyncThunk('general/downloadFile', async (idFile) => {
  try {
    const file = await downloadFileAxios(idFile);
    showAlertSuccErr({
      title: 'Archivo descargado con exito',
      icon: 'success',
    });
    return file.data;
  } catch (error) {
    console.error('Error al descargar el archivo', error);
    showAlertSuccErr({
      title: 'Error al descargar el archivo',
      icon: 'error',
    });
    throw error;
  }
});

export const downloadFileContainer = createAsyncThunk(
  'general/downloadFileContainer',
  async (idFile) => {
    try {
      const file = await downloadFileContainerAxios(idFile);
      showAlertSuccErr({
        title: 'Archivo descargado con exito',
        icon: 'success',
      });
      return file.data;
    } catch (error) {
      console.error('Error al descargar el archivo', error);
      showAlertSuccErr({
        title: 'Error al descargar el archivo',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const sendMail = createAsyncThunk('general/sendMail', async (commentToCreate) => {
  try {
    const formData = new FormData();
    console.log('commentToCreate.file', commentToCreate.file)
    formData.append('comment', commentToCreate.comment);
    formData.append('activity_id', commentToCreate.activity_id);
    formData.append('state', commentToCreate.state);
    formData.append('idOperation', commentToCreate.idOperation);
    formData.append('internal', commentToCreate.internal_comment || false);
    if (commentToCreate.file && commentToCreate.file.length > 0) {
      formData.append('files', JSON.stringify(commentToCreate.file));
    }
    console.log('commentToCreate', commentToCreate);
    if (commentToCreate.additionalEmails.length > 0)
      formData.append('additionalEmails', commentToCreate.additionalEmails);
    const response = await sendMailAxios(formData);
    return response.data;
  } catch (error) {
    console.error('Error al notificar', error);
    throw error;
  }
});

export const sendMailContainer = createAsyncThunk(
  'general/sendMailContainer',
  async (commentToCreate) => {
    try {
      const formData = new FormData();
      console.log('commentToCreate.file', commentToCreate.file)
      formData.append('comment', commentToCreate.comment);
      formData.append('container_id', commentToCreate.container_id);
      formData.append('activity_id', commentToCreate.activity_id);
      formData.append('idOperation', commentToCreate.idOperation);
      formData.append('internal', commentToCreate.internal_comment || false);
      if (commentToCreate.file && commentToCreate.file.length > 0) {
        formData.append('files', JSON.stringify(commentToCreate.file));
      }
      console.log('commentToCreate', commentToCreate);
      if (commentToCreate.additionalEmails.length > 0)
        formData.append('additionalEmails', commentToCreate.additionalEmails);
      const response = await sendMailContainerAxios(formData);
      return response.data;
    } catch (error) {
      console.error('Error al notificar', error);
      throw error;
    }
  },
);

export const resendMail = createAsyncThunk('general/resendMail', async (data) => {
  try {
    const response = await resendMailAxios(data);
    return response.data;
  } catch (error) {
    console.error('Error al notificar', error);
    throw error;
  }
});

export const resendMailContainer = createAsyncThunk('general/resendMailContainer', async (data) => {
  try {
    const response = await resendMailContainerAxios(data);
    return response.data;
  } catch (error) {
    console.error('Error al notificar', error);
    throw error;
  }
});

export const saveOperationDraft = createAsyncThunk('general/saveOperationDraft', async (data) => {
  try {
    const resp = await saveOperationDraftAxios(data);
    showAlertSuccErr({
      title: 'Borrador guardado exitosamente',
      icon: 'success',
    });
    return resp.data;
  } catch (error) {
    console.error('Error al guardar la operación', error);
    showAlertSuccErr({
      title: 'Error al guardar borrador',
      icon: 'error',
    });
    throw error;
  }
});

export const getUsers = createAsyncThunk('general/getUsers', async () => {
  try {
    const response = await getUsersAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getExternalUsers = createAsyncThunk('general/getExternalUsers', async () => {
  try {
    const response = await getExternalUsersAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const inactiveUser = createAsyncThunk('general/inactiveUser', async (data) => {
  try {
    const response = await inactiveUserAxios(data);
    showAlertSuccErr({
      title: 'Usuario inactivado exitosamente',
      icon: 'success',
    });
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al inactivar el usuario',
      icon: 'error',
    });
    throw error;
  }
});

export const getBusinesslines = createAsyncThunk('general/getBusinesslines', async () => {
  try {
    const response = await getBusinesslinesAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getRoles = createAsyncThunk('general/getRoles', async () => {
  try {
    const response = await getRolesAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const changeRole = createAsyncThunk('general/changeRole', async (data) => {
  try {
    const response = await changeRoleAxios(data);
    showAlertSuccErr({
      title: 'Rol cambiado exitosamente',
      icon: 'success',
    });
    return response;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al cambiar el rol del usuario',
      icon: 'error',
    });
    throw error;
  }
});

export const createBusinessLine = createAsyncThunk('general/createBusinessLine', async (data) => {
  try {
    const response = await createBusinessLineAxios(data);
    showAlertSuccErr({
      title: 'Línea de negocio agregada exitosamente',
      icon: 'success',
    });
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al agregar la línea de negocio del usuario',
      icon: 'error',
    });
    throw error;
  }
});

export const addCompanyToUser = createAsyncThunk('general/addCompanyToUser', async (data) => {
  try {
    const response = await addCompanyToUserAxios(data);
    showAlertSuccErr({
      title: 'Compañía asociada exitosamente',
      icon: 'success',
    });
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al asociar la comañía al usuario',
      icon: 'error',
    });
    throw error;
  }
});

export const removeBusinessLine = createAsyncThunk('general/removeBusinessLine', async (data) => {
  try {
    const response = await removeBusinessLineAxios(data);
    showAlertSuccErr({
      title: 'Línea de negocio eliminada exitosamente',
      icon: 'success',
    });
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al eliminar la línea de negocio del usuario',
      icon: 'error',
    });
    throw error;
  }
});
export const removeCompanyToUser = createAsyncThunk('general/removeCompanyToUser', async (data) => {
  try {
    const response = await removeCompanyToUserAxios(data);
    showAlertSuccErr({
      title: 'Compañía desasociada exitosamente',
      icon: 'success',
    });
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Hubo un error al desasociar la comañía del usuario',
      icon: 'error',
    });
    throw error;
  }
});

export const getAnalysts = createAsyncThunk('general/getAnalysts', async (data) => {
  try {
    const response = await getAnalystsAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const getAllCompanies = createAsyncThunk('general/getAllCompanies', async () => {
  try {
    const response = await getAllCompaniesAxios();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOperationdraftbyid = createAsyncThunk(
  'general/getOperationdraftbyid',
  async (operationid) => {
    try {
      const operation = await getOperationdraftbyidAxios(operationid);
      return operation.data;
    } catch (error) {
      console.error('Error al obtener las operaciónes de la dynamo', error);
      showAlertSuccErr({
        title: 'Error al obtener los borradores',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const deleteOperationDraft = createAsyncThunk(
  'geenral/deleteOperationDraft',
  async (operationid) => {
    try {
      const operation = await deleteOperationDraftAxios(operationid);
      return operation.data;
    } catch (error) {
      console.error('Error al eliminar la operación de la dynamo', error);
      showAlertSuccErr({
        title: 'Error al eliminar el borrador',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const fetchQuickSightUrl = createAsyncThunk(
  'general/fetchQuickSightUrl',
  async ({ dashboardId }) => {
    try {
      const response = await getUrlQuickSightAxios(dashboardId);
      return response.data;
    } catch (error) {
      console.error('Error al obtener la URL de QuickSight', error);
      showAlertSuccErr({
        title: 'Error al cargar el reporte',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const getEmails = createAsyncThunk('general/getEmails', async (operationId) => {
  try {
    if (!operationId) return [];
    const response = await getEmailsAxios(operationId);
    return response.data;
  } catch (error) {
    console.error(error);
    showAlertSuccErr({
      title: 'Error al obtener los correos',
      icon: 'error',
    });
    throw error;
  }
});

export const getUsersResponsity = createAsyncThunk(
  'general/usersCanBeResponsable',
  async (data) => {
    try {
      const response = await getUsersResponsityAxios(data?.businessline_id, data?.company_id);
      return response.data;
    } catch (error) {
      console.error(error);
      showAlertSuccErr({
        title: 'Error al obtener los Usuarios',
        icon: 'error',
      });
      throw error;
    }
  },
);

export const postChangeOperationResponsable = createAsyncThunk(
  'general/changeResponsable',
  async (data) => {
    try {
      const response = await postChangeResponsableOperationAxios(data);
      showAlertSuccErr({
        title: 'Operación modificada con exito',
        icon: 'success',
      });
      return response.data;
    } catch (error) {
      console.error(error);
      showAlertSuccErr({
        title: 'Error al cambiar el responsable de la operación',
        icon: 'error',
      });
      throw error;
    }
  },
);
